<template>
  <header
    class="corzo-header-wrap corzo-header-style-plain corzo-style-menu-right corzo-sticky-navigation corzo-style-fixed"
    data-navigation-offset="75">
    <div class="corzo-header-background"></div>
    <div class="corzo-header-container corzo-container">
      <div class="corzo-header-container-inner clearfix">
        <div class="corzo-logo corzo-item-pdlr" style="padding-bottom: 30px;">
          <div class="corzo-logo-inner">
            <a class="corzo-fixed-nav-logo" href="#/">
              <img src="../assets/logo.png" alt="" width="123" height="34" title="hp2-logo"/></a>
            <a class="corzo-orig-logo" href="#/">
              <img src="../assets/logo.png" alt="" width="123" height="34" title="hp2-logo"/></a>
          </div>
        </div>
        <div class="corzo-navigation corzo-item-pdlr clearfix">
          <div class="corzo-main-menu" id="corzo-main-menu">
            <ul id="menu-main-navigation-1" class="sf-menu">
              <li
                class="menu-item menu-item-home current-menu-item page_item page-item-12613 current_page_item current-menu-ancestor current-menu-parent current_page_parent current_page_ancestor menu-item-has-children corzo-normal-menu">
                <a href="index.html" class="sf-with-ul-pre">
                  <span class="corzo-menu-item-description">Home</span>首页</a>
              </li>
              <li class="menu-item menu-item-has-children corzo-normal-menu">
                <a class="sf-with-ul-pre" v-on:click="goto('news/list/1')">
                  <span class="corzo-menu-item-description">News</span>匯德动态</a>
                <ul class="sub-menu">
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('news/list/2')">匯德新闻</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('news/list/3')">媒体报道</a></li>
                </ul>
              </li>
              <li class="menu-item menu-item-has-children corzo-normal-menu">
                <a class="sf-with-ul-pre" v-on:click="goto('about')">
                  <span class="corzo-menu-item-description">About Us</span>匯德文化</a>
                <ul class="sub-menu">
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('about')">企业理念</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('about')">专业团队</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('about')">社会责任</a></li>
                </ul>
              </li>
              <li class="menu-item menu-item-has-children corzo-normal-menu">
                <a href="#/" class="sf-with-ul-pre">
                  <span class="corzo-menu-item-description">Services</span>匯德服务</a>
                <ul class="sub-menu">
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('services/5')">升学易</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('services/1')">离岸家族服务</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('services/2')">跨境企业服务</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('services/3')">离岸资产配置</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('services/4')">海外家族办公室设立</a></li>
                </ul>
              </li>
              <li class="menu-item menu-item-has-children corzo-normal-menu">
                <a class="sf-with-ul-pre" v-on:click="goto('contact')">
                  <span class="corzo-menu-item-description">Contact Us</span>联系匯德</a>
                <ul class="sub-menu">
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('partner')">成为城市合伙人</a></li>
                  <li class="menu-item" data-size="60">
                    <a v-on:click="goto('contact')">联系我们</a></li>
                </ul>
              </li>
<!--              <li class="menu-item menu-item-has-children corzo-normal-menu">-->
<!--                <a href="#/" class="sf-with-ul-pre">-->
<!--                  <span class="corzo-menu-item-description">News</span>新闻中心</a>-->
<!--                <ul class="sub-menu">-->
<!--                  <li class="menu-item">-->
<!--                    <a href="#/">公司动态</a></li>-->
<!--                  <li class="menu-item">-->
<!--                    <a href="#/">离岸课堂</a></li>-->
<!--                </ul>-->
<!--              </li>-->
            </ul>
          </div>
        </div>
        <!-- corzo-navigation --></div>
      <!-- corzo-header-inner --></div>
    <!-- corzo-header-container --></header>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    goto (path) {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      location.href = '#/' + path
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue